module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isshow) ? _c('Report', {
    attrs: {
      "allKip": _vm.allChildKp,
      "iserrorknow": _vm.errorknow
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-70971900", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70971900"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/team/details.vue
// module id = 391
// module chunks = 6